import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { STORAGE_KEY as CONSENT_KEY, setAdsPersonalisation } from './components/CookieConsent.jsx';
import './styles/main.css';

// Queue the personalisation signal before React mounts, so it is set ahead of
// the first slot request from the tag in index.html. Anything other than a
// stored, explicit yes means non-personalised: a visitor who has not answered
// the banner yet must not be treated as having agreed.
(function () {
  let allowed = false;
  try {
    const stored = JSON.parse(localStorage.getItem(CONSENT_KEY));
    allowed = stored?.advertising === true;
  } catch { /* ignore — no consent on record means no personalisation */ }
  setAdsPersonalisation(allowed);
})();

// FE-024: align with useDarkMode — check localStorage first, then OS preference
(function () {
  try {
    const stored = localStorage.getItem('tm-theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    document.documentElement.setAttribute('data-theme', stored ?? (prefersDark ? 'dark' : 'light'));
  } catch { /* ignore — storage may be unavailable */ }
})();

// Pick up the route's inlined data slice before anything renders, so the pages'
// state initialisers see it (api.js `pageData()`). It ships as an inert JSON
// block rather than an executable inline script because the site's CSP is
// `script-src 'self'`; see scripts/prerender.js.
(function () {
  try {
    const el = document.getElementById('tm-page-data');
    if (el) window.__TM_PAGE__ = JSON.parse(el.textContent);
  } catch (err) {
    // A malformed payload must not take the page down: without it the app just
    // falls back to fetching data.json as it always did.
    console.error('Failed to parse prerendered page data:', err);
  }
})();

// Every route is prerendered to static HTML at build time (scripts/prerender.js),
// so attach to that markup instead of throwing it away and re-rendering. Pages
// seed their first render from the inlined `window.__TM_PAGE__` payload, which
// is what lets the server and client trees agree. `createRoot` remains the
// fallback for any URL the build did not emit, such as the legacy /episode/:id
// route, where #root is genuinely empty.
const container = document.getElementById('root');
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}
